//Historico de agendamentos


import React from 'react';
import './PublicGridAgendamento.css';

export default function PublicGridAgendamento({ data, onSelecionarHorario }) {

  const diasSemana = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado'];
  const dataObj = new Date(data[0]?.data);
  const diaSemanaJS = dataObj.getDay() + 1;  
  const diaSemana = diasSemana[diaSemanaJS];

  return (
    <div className="Grid-container-agendamentos">
      <table className="Grid-table-agendamentos">
        <thead>
          <tr>
            <th>Data</th>
            <th>Dia</th>
            <th>Horário</th>
            <th>Descrição</th>
          </tr>
        </thead>

        <tbody>
          {data.map((h, index) => (
            <tr
              key={index}
              className={h.status === 'Disponível' ? 'disponivel' : 'indisponivel'}

              onClick={() => {
                console.log('Linha clicada:', h);
                if (h.status === 'Disponível') {
                  onSelecionarHorario(h);
                }
              }}


              style={{ cursor: h.status === 'Disponível' ? 'pointer' : 'default' }}
            >
              <td>{h.data}</td>
              <td>{diaSemana}</td>
              <td>{h.horario}</td>
              <td>{h.status === 'Disponível' ? 'Horário Disponível' : 'Fechado nessa data'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
